export const validateForm = (formValues) => {
  const errors = {};

  //Nombre valiadtion
  if (!formValues?.firstName) {
    errors.firstName = "No puede estar vacío el Nombre";
  } else if (formValues?.firstName.length < 2) {
    errors.firstName = "Ingrese un nombre valido.";
  }
  //LastName validation
  if (!formValues?.lastName) {
    errors.lastName = "No puede estar vacio el Apellido";
  } else if (formValues?.lastName.length < 2) {
    errors.lastName = "Ingrese un Apellido valido.";
  }
  // dateBirth validation (formato DD/MM/YYYY)
  if (!formValues?.dateBirth) {
    errors.dateBirth = "No puede estar vacío";
  } else {
    const [day, month, year] = formValues.dateBirth.split("/");
    const birthDate = new Date(`${year}-${month}-${day}`);
    const today = new Date();

    // Validar fecha válida
    if (isNaN(birthDate.getTime())) {
      errors.dateBirth = "Fecha inválida";
    }
    // Validar que no sea futura
    else if (birthDate > today) {
      errors.dateBirth = "La fecha no puede ser futura";
    }
    // Validar mayoría de edad
    else {
      const age = calculateAge(birthDate);
      if (age < 18) {
        errors.dateBirth = "Debes ser mayor de 18 años";
      } else if (age > 120) {
        errors.dateBirth = "Edad no válida";
      }
    }
  }

  //Gender validation
  if (!formValues?.gender) {
    // console.log(formValues?.gender);

    errors.gender = "Nopuede estar vacio";
  }
  //nickName validation
  if (!formValues?.nickName) {
    errors.nickName = "No puede estar vacío el Nickname.";
  } else if (formValues?.nickName.length < 2) {
    errors.nickName = "Campo obligatorio.";
  }
  //Street validation
  if (!formValues?.street) {
    errors.street = "La calle no puede estar vacia.";
  } else if (formValues?.street.length < 2) {
    errors.street = "Campo obligatorio";
  }
  //City validation
  if (!formValues?.city) {
    errors.city = "La ciudad no puede estar vacia.";
  } else if (formValues?.city.length < 2) {
    errors.city = "Campo obligatorio";
  }
  //State validation
  if (!formValues?.state) {
    errors.state = "El estado no puede estar vacio.";
  } else if (formValues?.state.length < 2) {
    errors.state = "Campo obligatorio";
  }
  //PostalCode validation
  const regeCP = /^[0-9]{5}$/;
  if (!formValues?.postalCode) {
    errors.postalCode = "C.P no valido";
  } else if (!regeCP.test(formValues?.postalCode)) {
    errors.postalCode = "No valido";
  }

  //phoneNumber validation
  if (!formValues?.phoneNumber) {
    errors.phoneNumber = "Número no valído";
  } else if (formValues?.phoneNumber.length < 10) {
    errors.phoneNumber = "Verifica tu numero";
  }

  // Email validation

  return errors;
};

const calculateAge = (birthDate) => {
  const today = new Date();
  const birthDateObj = new Date(birthDate);

  let age = today.getFullYear() - birthDateObj.getFullYear();
  const monthDiff = today.getMonth() - birthDateObj.getMonth();

  // Ajustar si aún no ha pasado el mes de cumpleaños
  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDateObj.getDate())
  ) {
    age--;
  }

  return age;
};

export const validateNewFormUser = (formValues) => {
  //Nombre valiadtion
  const errors = {};
  if (!formValues?.firstName) {
    errors.firstName = "No puede estar vacío el Nombre";
  } else if (formValues?.firstName.length < 2) {
    errors.firstName = "Ingrese un nombre valido.";
  }
  // Name validation
  if (!formValues?.nickName) {
    errors.nickName = "El nombre no puede estar vacío";
  } else if (formValues?.nickName.length < 2) {
    errors.nickName = "Campo obligatorio";
  } else if (/\s/.test(formValues.nickName)) {
    errors.nickName = "No puede tener espacions este campo.";
  }
  // Email validation
  if (!formValues?.email) {
    errors.email = "El email no puede estar vacío.";
  } else if (!/\S+@\S+\.\S+/.test(formValues?.email)) {
    errors.email = "E-mail no valido.";
  }
  // Password validation
  if (!formValues?.password) {
    errors.password = "La contraseña no puede estar vacía.";
  } else if (formValues?.password.length < 8) {
    errors.password = "Debe de ser mayor a 8 caracteres.";
  }
  return errors;
};

export const validateFormLogin = (userData) => {
  const errors = {};

  // Email validation
  if (!userData.email) {
    errors.email = "El email es requerido.";
  } else if (!/\S+@\S+\.\S+/.test(userData.email)) {
    errors.email = "E-mail no valido.";
  }

  // Password validation
  if (!userData.password) {
    errors.password = "La contraseña es requerida.";
  }
  return errors;
};
